import React, { useEffect, useRef, useState } from "react";
import "./orderRecipient.scss";
import { useNavigate, useParams } from "react-router-dom";
import paymentStore from "../../../stores/paymentStore";
import orderStore from "../../../stores/orderStore";
import usersStore from "../../../stores/usersStore";
import productStore from "../../../stores/productStore";
import couponStore from "../../../stores/couponStore";
import addressStore from "../../../stores/addressStore";
import orderDeliveryStatusTimeStore from "../../../stores/orderDeliveryStatusTimeStore";

import InvoiceBill from "../../../components/invoiceBill/InvoiceBill";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { Button } from "@mui/material";

// Icons
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import authStore from "../../../stores/authStore";

const OrderRecipient = () => {
  const navigate = useNavigate();
  const param = useParams();
  const PaymentStore = paymentStore();
  const OrderStore = orderStore();
  const UsersStore = usersStore();
  const ProductStore = productStore();
  const CouponStore = couponStore();
  const AddressStore = addressStore();
  const AuthStore = authStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();
  const [orderDetails, setOrderDetails] = useState(null);
  const [statusBackgroundColor, setStatusBackgroundColor] = useState(null);
  const [statusColor, setStatusColor] = useState(null);
  const [deliveryStatus, setDeliveryStatus] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    if (AuthStore.loggedIn) {
      await ProductStore.fetchAllProduct();
      await PaymentStore.fetchAllPayment();
      await OrderStore.fetchAllOrders();
      await UsersStore.fetchAllUsers();
      await AddressStore.fetchAllUserAddress();
      await CouponStore.fetchAllCoupon();
      await OrderDeliveryStatusTimeStore.fetchAllOrderDeliveryStatusTime();
    }
  };

  // PDF
  const pdfExportComponent = useRef(null);

  const handleExportWithComponent = (event) => {
    pdfExportComponent.current.save();
  };
  // PDF

  useEffect(() => {
    if (
      !PaymentStore.isLoading &&
      !OrderStore.isLoading &&
      !UsersStore.isLoading &&
      !ProductStore.isLoading &&
      !CouponStore.isLoading &&
      !OrderDeliveryStatusTimeStore.isLoading &&
      !AddressStore.isLoading
    ) {
      init();
    }
  }, [
    PaymentStore.isLoading,
    OrderStore.isLoading,
    UsersStore.isLoading,
    ProductStore.isLoading,
    CouponStore.isLoading,
    OrderDeliveryStatusTimeStore.isLoading,
    AddressStore.isLoading,
  ]);

  const init = () => {
    for (let i = 0; i < PaymentStore.mPaymentDetails.length; i++) {
      if (PaymentStore.mPaymentDetails[i]._id === param.paymentID) {
        // order find
        const oProduct = [];
        let history = "";
        for (let o = 0; o < OrderStore.orderDetail.length; o++) {
          if (
            OrderStore.orderDetail[o].paymentID ===
            PaymentStore.mPaymentDetails[i]._id
          ) {
            for (let p = 0; p < ProductStore.mProduct.length; p++) {
              if (
                ProductStore.mProduct[p]._id ===
                OrderStore.orderDetail[o].productID
              ) {
                oProduct.push({
                  _id: OrderStore.orderDetail[o]._id,
                  productImage: ProductStore.mProduct[p].productImages[0],
                  productName: ProductStore.mProduct[p].productName,
                  qty: OrderStore.orderDetail[o].quantity,
                  price: OrderStore.orderDetail[o].purchasePrice,
                });
              }
            }
            // orderDeliveryStatusTime
            for (
              let d = 0;
              d < OrderDeliveryStatusTimeStore.orderDeliveryStatusTime.length;
              d++
            ) {
              if (
                OrderDeliveryStatusTimeStore.orderDeliveryStatusTime[d]._id ===
                OrderStore.orderDetail[o].orderDeliveryStatusTimeID
              ) {
                history =
                  OrderDeliveryStatusTimeStore.orderDeliveryStatusTime[d];
              }
            }

            setDeliveryStatus(OrderStore.orderDetail[o].order_delivery_status);
            if (OrderStore.orderDetail[o].order_delivery_status === "Pending") {
              setStatusColor("#E4A11B");
              setStatusBackgroundColor("rgba(240, 172, 78,  0.200)");
            } else if (
              OrderStore.orderDetail[o].order_delivery_status === "Preparing"
            ) {
              setStatusColor("#9FA6B2");
              setStatusBackgroundColor("rgba(159, 166, 178,  0.200)");
            } else if (
              OrderStore.orderDetail[o].order_delivery_status ===
              "Out Of Delivery"
            ) {
              setStatusColor("#54B4D3");
              setStatusBackgroundColor("rgba(84, 180, 211,  0.200)");
            } else if (
              OrderStore.orderDetail[o].order_delivery_status === "Delivered"
            ) {
              setStatusColor("#14A44D");
              setStatusBackgroundColor("rgba(20, 164, 77,  0.200)");
            } else if (
              OrderStore.orderDetail[o].order_delivery_status === "Return"
            ) {
              setStatusColor("#DC4C64");
              setStatusBackgroundColor("rgba(220, 76, 100,  0.200)");
            }
          }
        }
        // PaymentStore.mPaymentDetails[i].couponID,
        let couponName = "";
        if (PaymentStore.mPaymentDetails[i].couponID) {
          for (let c = 0; c < CouponStore.coupon.length; c++) {
            if (
              CouponStore.coupon[c]._id ===
              PaymentStore.mPaymentDetails[i].couponID
            ) {
              couponName = CouponStore.coupon[i].couponName;
            }
          }
        }

        // PaymentStore.mPaymentDetails[i].addressID,
        let shippingAddress = "";
        for (let a = 0; a < AddressStore.userAddress.length; a++) {
          if (
            PaymentStore.mPaymentDetails[i].addressID ===
            AddressStore.userAddress[a]._id
          ) {
            shippingAddress = AddressStore.userAddress[a];
          }
        }

        // PaymentStore.mPaymentDetails[i].userID,
        let customer = "";
        for (let u = 0; u < UsersStore.allUser.length; u++) {
          if (
            PaymentStore.mPaymentDetails[i].userID === UsersStore.allUser[u]._id
          ) {
            customer = UsersStore.allUser[u];
          }
        }

        setOrderDetails({
          _id: param.paymentID,
          payment_at: PaymentStore.mPaymentDetails[i].payment_at,
          subTotal: PaymentStore.mPaymentDetails[i].subTotal,
          discount: PaymentStore.mPaymentDetails[i].discount,
          couponDiscount: PaymentStore.mPaymentDetails[i].couponDiscount,
          total: PaymentStore.mPaymentDetails[i].total,
          paymentType: PaymentStore.mPaymentDetails[i].paymentType,
          razorpay_order_id: PaymentStore.mPaymentDetails[i].razorpay_order_id,
          razorpay_payment_id:
            PaymentStore.mPaymentDetails[i].razorpay_payment_id,
          oProduct,
          history,
          couponName,
          shippingAddress,
          customer,
        });
      }
    }
  };

  return (
    <div className="order-recipient">
      {orderDetails ? (
        <>
          <div className="btn-container">
            <Button
              className="print-btn"
              variant="outlined"
              onClick={handleExportWithComponent}
            >
              <p>Print</p>
            </Button>
          </div>
          <div className="content">
            <PDFExport
              fileName={`Report for ${new Date().getFullYear()}`}
              ref={pdfExportComponent}
            >
              <InvoiceBill orderDetails={orderDetails} />
            </PDFExport>
          </div>
        </>
      ) : (
        "Loading..."
      )}
    </div>
  );
};

export default OrderRecipient;
